import { Component, Input } from '@angular/core';

import { DividerComponent } from '../../../common/divider/divider.component';
import { IconComponent } from '../../../common/icon/icon.component';
import { FileSizePipe } from '../../../common/pipes/file-size.pipe';
import { SpinnerComponent } from '../../../common/spinner/spinner.component';
import { AttachmentPlaceloader } from './attachment-placeloader.types';

@Component({
  selector: 'rt-attachment-placeloader',
  templateUrl: 'attachment-placeloader.component.html',
  styleUrls: [
    '../attachment-item/attachment-item.component.less',
    './attachment-placeloader.component.less',
  ],
  imports: [DividerComponent, FileSizePipe, IconComponent, SpinnerComponent],
})
export class AttachmentPlaceloaderComponent {
  @Input() public attachmentPlaceloader: AttachmentPlaceloader;
}
